<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js'

import shave from "shave";

export default {
  mixins: [fandomBasicMixin],
  props: {
    trackTileClick: Array,
    tileAdditionalPaddingClass: String
  },
  mounted() {
    this.shaveHeight();
    $(window).on("debouncedResize", this.shaveHeight);
    // google analytics
    if (!!this.trackTileClick){
      Vue.nextTick(() => {
        KenwoodItaly.trackLinkVisited(`#ref-${this.easyadminId}-link`, this.trackTileClick[0], this.trackTileClick[1], this.content.name);
      });
    }
  },
  updated() {
    this.shaveHeight();
  },
  beforeDestroy() {
    $(window).off("debouncedResize");
  },
  methods: {
    getContentResponsiveImage: Fandom.getContentResponsiveImage,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getContentURL: Fandom.getContentURL,
    shaveHeight() {
      Vue.nextTick(() => {
        shave(`#tile-description-${this.easyadminId}`, this.getDescriptionHeight());
      });
    },
    getDescriptionHeight() {
      const height = Math.round($(`#tile-footer-${this.easyadminId}`).height() - $(`#tile-title-${this.easyadminId}`).height()) - 16;
      return height;
    },
  },
  computed: {
    tileUrl() {
      return this.content.url ? this.content.url.url : this.getContentURL(this.content);
    },
    thumbnailUrl() {
      return this.content.thumbnail ? this.getBackgroundUrl(this.content.thumbnail.url) : '';
    },
    owner() {
      if(Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) {
        return this.pageModel.id_to_user[this.content.owned_by];
      }
    },
  }
};
</script> 

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="position-relative h-100" tile-article>
    <a :href="tileUrl" :target="getTarget(content.url)" :style="{'background-color': content.background_color}" class="d-flex flex-column w-100 h-100" :id="`ref-${this.easyadminId}-link`">
      <div class="w-100 tile-article__thumbnail bg-transition">
        <div class="w-100 h-100 bg-cover-center bg ar-16by9" :style="{'background-image': thumbnailUrl}"></div>
      </div>
      <div class="w-100 flex-grow-1 d-flex flex-column" :class="[tileAdditionalPaddingClass, {'px-4': content.background_color}]" :id="`tile-footer-${easyadminId}`">
        <div class="flex-grow-1 pb-2">
          <h5 class="text-dark my-4" :id="`tile-title-${easyadminId}`"> {{ content.title }} </h5>
          <p class="text-dark font-sm description mb-4" :id="`tile-description-${easyadminId}`" v-html="content.description"> </p>
        </div>
        <div v-if="owner" class="d-flex px-0" :class="content.background_color ? 'pb-4' : 'pb-3'">
          <div v-if="owner" class="owner-info d-flex align-items-center pl-0" >
            <div v-if="owner.avatar" class="owner-avatar bg-cover-center" :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"></div>
            <span class="pl-2 font-sm text-dark">By {{owner.username}}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<style lang="scss">
[tile-article] {
  & > a:hover {
    text-decoration: none;
  }

  .description, .description p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  .description > p {
    margin-bottom: 0;
  }

  .owner-info {
    .owner-avatar {
      height: 42px;
      width: 42px;
      border-radius: 50%;
    }
  }
  
}
</style>